<template>
<div>

    <div class="project-container" v-if="project.type!= 'homepage'"  v-bind:id="project.id" v-bind:style="{ height : windowHeight + 'px'  }" >

        <div class="project-slide-track" >
            <project-image 
            v-for="(image, imageIndex) in project.images" 
            :image="image" 
            :projectIndex="index" 
            :project="project" 
            :imageIndex="imageIndex"  
            :currentSlide="currentSlide"
            :showInfo="showInfoFlag"
            ref="images"
            v-on:ready="onIsReady"
            v-on:animation="onAnimation"
            > </project-image>
        </div>

        <div class="mobile-project-info-overlay" v-if="mobileProjectInfo"
            v-bind:style="{ width: layout.width + 'px', height: layout.height +'px' }"
            >
            <a @click="hideMobileProjectInfo" class="icon close mobile">
                <img src="/static/images/icons/HMJ-Close_mobil.svg" alt="close icon">
            </a>

            <div class="content"
                v-bind:style="{marginLeft : layout.offsetLeft + 'px', marginTop : layout.offsetTop + 'px'}"
            >
            <div class="content-cell">
                <h4 class="title">{{project.title[lang]}}</h4>
                <p>
                {{project.text[lang].description}}
                </p>
            </div>
        </div>
        </div>

        <div class="project-info-line" @click="showInfo" v-if="layout.type == 'large'" >
            <span class="project-info title">{{project.title[lang]}}</span>
            <span class="project-info page">{{currentSlide + 1}}/{{totalImages}}</span>  
            <a  class="project-info info-trigger" v-if="ready">Info</a>
        </div>

        <div class="project-info-mobile" v-if="layout.type != 'large' && layout.orientation == 'portrait'">

            <span class="project-info title" v-if="layout.type =='medium' && layout.orientation == 'portrait'">{{project.title[lang]}}</span>
            <span class="project-info page" v-if="layout.type =='medium' && layout.orientation == 'portrait'">{{currentSlide + 1}}/{{totalImages}}</span>  

            <a  class="project-info info-trigger portrait" v-if="layout.orientation == 'portrait'" 
                @click="showMobileProjectInfo"
                >Info</a>
        </div>

            <a  class="project-info-mobile-landscape " v-if="layout.orientation == 'landscape' && layout.type !='large' && currentId == project.id" 
                @click="showMobileProjectInfo"
                >
                <span v-if="layout.mobileNavigation !== true">Info</span> 
                </a>
    </div>


    <div class=" homepage" v-if="project.type== 'homepage'"  
        style="overflow: hidden"
        v-bind:id="project.id" 
        v-bind:style="{ height : windowHeight + 'px', width : windowWidth + 'px' }" >
        <div class="homepage-content"
            style="background-image: url(/static/images/startseite/Highline-Kapuzenturm-2-09-Neu.jpg); background-repeat: no-repeat;"
            v-bind:class="{ light : lightSiteTitle }"
            v-bind:style="{ height : windowHeight - windowMargin * 2 + 'px', width : windowWidth - windowMargin*2 + 'px', marginTop : windowMargin + 'px', backgroundImage : 'url(/static/images/startseite/'+ startImage.file+')', backgroundPosition: startImage.position  }" >
            <div class="contact-info hide-for-small-only hide-for-medium-only">
                <span><a href='mailto:contact@maier-jantzen.de'>contact@maier-jantzen.de</a></span>
                <span><a href="/seite/contact">+49 171 19 63 601</a></span>
            </div>

            <h1 class="site-title"
                v-bind:style="{ paddingTop : windowHeight * 0.3 + 'px'  }"
                >Henning Maier-Jantzen <em>Photography</em></h1>

                <div class="homepage-arrow" v-bind:style="{ width : windowWidth - windowMargin*2 + 'px' }" >
                </div>

        </div>
    </div>
</div>
</template>

<script>
import store from './store/store';
var projectImage = require('./projectImage');

export default {
    
    components : { 'project-image' : projectImage },
    props : ['project', 'index'],
     computed : {

        lang()                  { return store.state.language },
        windowHeight()          { return store.state.layout.height; },
        windowWidth()           { return store.state.layout.width; },
        windowRatio()           { return store.getters.getLayoutRatio },
        windowMargin()          { return store.getters.getWindowMargin },
        currentId()             { return store.state.projectsCurrentId  },
        layout()                { return store.state.layout; },
        projectMove()              { return store.state.projectMove  },
        totalImages()           { return this.project.images.length; },
        slideTrackMaxTime()         { return this.project.images.length * this.windowWidth /10   },
        refImages()            { return this.$refs.images; },
        projectRerender()       { return store.state.projectRerender },
        lightSiteTitle()       {  
            if(this.startImage.caption == 'light') {
                return true;
            }
            return false;
        }
     },

     data() {
         return {
            scrollLeft : 0,
            imageIndex : 0,
            listen : true,
            lastMove : false,
            currentSlide : 0,
            showTitle : false,
            showInfoFlag : 0,
            ready : false,
            startImage : false,
            mobileProjectInfo : false,
         }
     },

     watch : {

         projectRerender : function(val, oldVal) {
                
             if( this.project.id == this.currentId ) {
                 console.info("Request rerender of current project");
                 var CorrectionConstant = 0;

                 this.renderProject();

                 // fix scroll position
                if(this.layout.type == 'small' || this.layout.type == 'medium') {
                    CorrectionConstant = this.layout.mobileGutter   * ( this.currentSlide  );
                }


                var targetPosition = this.project.images[this.currentSlide].view.scrollPosition + CorrectionConstant;

                $("#" + this.project.id + " .project-slide-track").velocity(
                    { marginLeft : -1 * Math.floor(targetPosition) - CorrectionConstant } ,
                    { easing : 'easeOutQuad', duration: 1   }
                );
                // fix


             }
         },
        currentId : function(val, oldVal) {  

            oldVal = oldVal || '';
            if(val == this.project.id && val != oldVal) { 
                this.renderProject();


                if( !store.state.route.params.index ) {
                        this.$router.push({ name : 'project', params : { slug : this.project.id } });
                        this.moveToStart();
                } else {
                    // jump to image
                    this.jumpToSlide( store.state.route.params.index )
                }
            }
        },

        projectMove : function(val, oldVal) {

            if(this.currentId != this.project.id) {
                return false;
            }

            if(val > 0)  {
                this.nextSlide();
            } else {
                this.prevSlide();
            }

            // hide sidebar for large screens on slide move
            if(store.state.layout.type == 'large') {
                
                store.commit('setSidebar', 1);
            }
        },


     },

     created : function() {
         
         this.startImage = this.project.images[Math.floor(Math.random()* this.project.images.length)];
         this.lastMove = Date.now();

     },


     methods: {

         nextSlide : function() {

            if(!this.listen) { return false; }

            var targetIndex = this.currentSlide + 1;
            if(targetIndex >= this.project.images.length) { 

                this.$emit('projectEnd');
                return false; 
            }

            this.listen = false;
            this.showInfoFlag = 0;

            var targetPosition = this.project.images[targetIndex].view.scrollPosition;
            console.log("Move " + this.project.id + " to " + targetPosition);

            this.currentSlide = targetIndex;
            this.loadImage(this.currentSlide, 1);

            var CorrectionConstant = 0;

            if(this.layout.type == 'small' || this.layout.type == 'medium') {
                CorrectionConstant = this.layout.mobileGutter * this.currentSlide;
            }


            $("#" + this.project.id + " .project-slide-track").velocity(
                { marginLeft : -1 * Math.floor(targetPosition) - CorrectionConstant  } ,
                { easing : 'easeOutQuad', duration: 700,  complete : this.handleCompleteMove.bind(this) }
            );

         },

         prevSlide : function() {

            if(!this.listen) { return false; }

            var targetIndex = this.currentSlide - 1;

            // are we at the start?
            if(targetIndex < 0) { 
                this.$emit('startReached');
                return false; 
            }

            this.listen = false;
            this.showInfoFlag = 0;

            var targetPosition = this.project.images[targetIndex].view.scrollPosition;
            console.log("Move " + this.project.id + " to " + targetPosition);

            this.currentSlide = targetIndex;

            this.loadImage(this.currentSlide, -1);
            var CorrectionConstant = 0;

            if(this.layout.type == 'small' || this.layout.type == 'medium') {
                CorrectionConstant = this.layout.mobileGutter * this.currentSlide;
            }

            $("#" + this.project.id + " .project-slide-track").velocity(
                { marginLeft : -1 * Math.floor(targetPosition) - CorrectionConstant } ,
                { easing : 'easeOutQuad', duration: 700,  complete : this.handleCompleteMove.bind(this) }
            );
         },

         moveToStart : function() {

             console.log("Move " + this.project.id + " to start");
            this.currentSlide = 0;
            $("#" + this.project.id + " .project-slide-track").velocity(
                { marginLeft : 0 } ,
                { easing: 'easeInOutCubic', duration: this.slideTrackMaxTime,  complete : this.handleCompleteMove.bind(this) }
            );
         },

         jumpToSlide : function(targetIndex) {

            // console.log("Jumpt to index " + targetIndex);
            // return false;
          
            console.info("JUMP to slide");

            this.listen = false;
            this.showInfoFlag = 0;
            this.currentSlide = Number( targetIndex );
            var CorrectionConstant = 0;

            if(this.layout.type == 'small' || this.layout.type == 'medium') {
                CorrectionConstant = this.layout.mobileGutter   * ( this.currentSlide  );
            }


            var targetPosition = this.project.images[targetIndex].view.scrollPosition + CorrectionConstant;

            $("#" + this.project.id + " .project-slide-track").velocity(
                { marginLeft : -1 * Math.floor(targetPosition) - CorrectionConstant } ,
                { easing : 'easeOutQuad', duration: 1,  complete : this.handleCompleteMove.bind(this) }
            );
            this.loadImage(this.currentSlide);
            this.$router.push({ name : 'project', params : { slug : this.project.id } });

         },

         handleCompleteMove : function() {
            
             this.lastMove = Date.now();
             this.listen = true;
             console.log("Update lastMove " + this.lastMove);
         },

         renderProject : function() {
             
             console.log("Render project #" + this.project.id)
             this.showInfoFlag = 1;

             if(!store.state.route.params.index) {
                 
                 this.loadImage(0, 1);
             }

             // edit length of title display here
             setTimeout(this.fadeOutInfo, 500)
         },

         fadeOutInfo : function() {
            this.showInfoFlag = 0;   
         },

         loadImage : function(index, direction) {

            if(this.project.type == 'homepage') { return false; }
            index = index || 0; 
            direction = direction || 1;

            if(direction > 0) {
                    for(var i=0; i<3; i++) {
                        this.lazyLoadImage(index + i);
                    }
            } else {
                
                    for(var i=0; i>-3; i--) {
                        this.lazyLoadImage(index + i);
                    }
            }

         },

         lazyLoadImage : function(index) {
            index = index || 0; 

            if(Number(index) < 0) { return false; }

            if(index < this.project.images.length  ) {

                this.$refs.images[index].unveil();

            }

         },

        showInfo : function() {

            if(!this.ready) {
                return false;
            }
            
            if(this.showInfoFlag < 2) {
                this.showInfoFlag = 2;
            } else {
                this.showInfoFlag = 0;
            }
         },

         showMobileProjectInfo : function() {
             this.mobileProjectInfo = true;
         },

         hideMobileProjectInfo : function() {
             this.mobileProjectInfo = false;
         },

         onIsReady : function() {
            
             this.ready = true;
         },

         onAnimation : function() {
            this.ready = false; 
         }



     }
}
</script>



// WEBPACK FOOTER //
// project.vue?035d763a